import CaseCard from "@/components/feature/CaseCard";
import SectionHeading from "@/components/base/SectionHeading";
import { cases } from "@/mocks/cases";

export default function LatestSection() {
  const latest = [...cases]
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, 6);

  return (
    <section id="latest" className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        eyebrow="Exclusive Feed"
        title="最新独家爆料"
        desc="新进入的线索在完成材料核对后公开。每条档案都能看到证据类型、出处与补充状态，点开即可顺着时间线自己推一遍。"
        actionHref="/archive"
        actionLabel="进入档案库"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {latest.map((item) => (
          <CaseCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}